import { embedUrl } from '@/utils/embed'

/** A YouTube or Vimeo video played inline (privacy-friendly YouTube address). */
export function VideoEmbed({ url, title }: { url: string; title: string }) {
  const src = embedUrl(url)
  if (!src) return null
  return (
    <div className="relative aspect-video w-full overflow-hidden rounded-card bg-black">
      <iframe
        src={src}
        title={title}
        className="absolute inset-0 size-full"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        loading="lazy"
        referrerPolicy="strict-origin-when-cross-origin"
      />
    </div>
  )
}
